import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import { StoryblokComponent, storyblokEditable } from '@storyblok/react';
import { string } from 'prop-types';
import React from 'react';
import { Helmet } from 'react-helmet';

import SectionNewsletter from '../../../containers/LandingPage/SectionNewsletter';
import useScreenSize from '../../../util/hooks/useScreenSize';
import StoryblokBlogPostFooter from '../components/BlogPost/StoryblokBlogPostFooter';
import StoryblokBlogPostHeroImage from '../components/BlogPost/StoryblokBlogPostHeroImage';
import AnnualPassAd from '../dataSourceComponents/AnnualPassAd';

/**
 * StoryblokBlogPostPageComponent component for the Storyblok.
 * @param {object} props
 * @param {object} props.blok
 * @param {string} props.blok._uid
 * @param {string[]} props.blok.categories
 * @param {string} props.blok.tags
 * @param {Object[]} props.blok.content
 * @param {object} props.blok.metatags
 * @param {string} props.blok.metatags.title
 * @param {string} props.blok.metatags.description
 * @param {string} props.blok.keywords
 * @param {VanSite.Storyblok.Image} props.blok.heroImage
 * @param {string} props.blok.position
 * @param {VanSite.Storyblok.Story} props.story
 * @returns {React.ReactNode}
 * @constructor
 */

const StoryblokBlogPostPageComponent = ({ blok, story }) => {
  const { first_published_at, published_at } = story;

  const { metatags } = blok;
  const { title = '' } = metatags || {};
  const { keywords } = blok;

  const { heroImage, position, categories, tags } = blok;

  const { isMobile } = useScreenSize();

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta content={metatags.description} name="description" />
        <meta content={keywords} name="keywords" />
      </Helmet>
      <StoryblokBlogPostHeroImage image={heroImage} position={position} />

      <Container maxWidth="xl">
        <Grid container spacing={4}>
          <Grid size={{ md: 8, xs: 12 }}>
            <Box key={blok._uid} {...storyblokEditable(blok)}>
              {blok.content?.map((nestedBlok) => (
                <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} />
              ))}
            </Box>
          </Grid>
          {!isMobile ? (
            <Grid size={{ md: 4 }}>
              <Box
                sx={{
                  height: '100%',
                  padding: {
                    md: '60px 0 40px',
                    lg: '96px 0 45px',
                  },
                }}
              >
                <Box
                  p={2}
                  sx={{
                    width: '100%',
                    borderTopLeftRadius: 2,
                    alignSelf: 'flex-start',
                    backgroundColor: 'background.paper',
                    boxShadow: 1,
                    borderRadius: 1,
                  }}
                >
                  <AnnualPassAd blok={blok} />
                  <Box my={6} />
                  <SectionNewsletter
                    direction="column"
                    googleCaptchaElementId="storyblokBlogPostNewsletterElementId"
                  />
                </Box>
              </Box>
            </Grid>
          ) : null}
        </Grid>
      </Container>
      <StoryblokBlogPostFooter
        categories={categories}
        publishDate={first_published_at || published_at}
        tags={tags}
      />
    </>
  );
};

export default StoryblokBlogPostPageComponent;
